<template>
  <div>
    <div v-if="scope.row.model.card_id === card.id">Текущая карта</div>
    <div v-if="scope.row.model.card_id !== card.id && scope.row.model.card && scope.row.model.card.user">
      <router-link
        style="text-decoration: none; white-space: nowrap"
        target="_blank"
        :to="{ name: 'Card', params: { id: scope.row.model.card_id } }"
      >
        {{scope.row.model.card.user.last_name}}
        {{Array.from(scope.row.model.card.user.first_name)[0]}}.

      </router-link>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: 'cascading-element-in-card-table-column',
  components: {},
  mixins: [],

  props: {
    scope: {type: Object, required: true},
  },
  computed: {
    ...mapGetters('card', {
      card: 'card',
    }),
  },
  data() {
    return {}
  },
  methods: {}
}

</script>

<style lang="scss">
@import "@/assets/css/project-variables";

</style>
